import React from 'react';
export function StickyBar() {
  return <div className="sticky top-0 z-50 w-full bg-primary text-white py-3 px-4 text-center text-sm md:text-base font-medium shadow-md" data-id="element-142">
      <p data-id="element-143">Solo por hoy · 3 bonos gratis incluidos</p>
    </div>;
}